export default "__VITE_ASSET__CqA6hIHY__"